"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWebsiteSubscriptionSalesforceSchema = void 0;
exports.CreateWebsiteSubscriptionSalesforceSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        oms: {
            properties: {
                orderId: {
                    type: 'string',
                },
                serviceContractId: {
                    type: 'string',
                },
                messageId: {
                    type: 'string',
                },
                transactionId: {
                    type: 'string',
                },
            },
            required: [
                'orderId',
                'serviceContractId',
                'messageId',
                'transactionId',
            ],
            type: 'object',
        },
        zuoraResponse: {
            properties: {
                accountNumber: {
                    type: 'string',
                },
                invoiceNumbers: {
                    items: {
                        type: 'string',
                    },
                    type: 'array',
                },
                orderNumber: {
                    type: 'string',
                },
                paymentMethodId: {
                    type: 'string',
                },
                reasons: {
                    items: {},
                    type: 'array',
                },
                status: {
                    type: 'string',
                },
                subscriptionNumbers: {
                    items: {
                        type: 'string',
                    },
                    type: 'array',
                },
                success: {
                    type: 'boolean',
                },
                zuoraTrackId: {
                    type: 'string',
                },
            },
            required: [
                'accountNumber',
                'orderNumber',
                'paymentMethodId',
                'status',
                'subscriptionNumbers',
                'success',
            ],
            type: 'object',
        },
    },
    required: [
        'oms',
        'zuoraResponse',
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,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